import styled, { css } from 'styled-components'
import { AsyncTypeahead, ClearButton } from 'react-bootstrap-typeahead'

export const StyledTypeahead = styled(AsyncTypeahead)`
  .dropdown-item {
    font-size: 0.8rem;
    font-weight: 300;
  }

  // Clear button alignment
  .rbt-aux .rbt-close {
    margin-top: 2px;
    z-index: 0;
    &:focus {
      outline: none;
    }
  }
  
  .rbt-input {
    // Give some space for the clear button to show
    padding-right: 30px;
    ${({ isRightIcon }) => isRightIcon && css`
      padding-right: 25px;
      .rbt-input-wrapper {
        margin-right: 1rem;
      }
    `}
    border-radius: 0;
  }

  a {
    // Give some space between list options
    padding: 0.5rem;
  }
`

export const StyledClearButton = styled(ClearButton)`
  color: ${({ theme }) => theme.palette.grayscale[4]};
`

